(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobilmax-infinite-list')) {
  customElements.define('mobilmax-infinite-list', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.section = this.closest('.shopify-section');
      this.selector = 'ul#product-grid, #product-grid > ul.product-grid, ul.collection-list, .blog-articles';
      this.grid = this.section?.querySelector(this.selector);
      this.controls = this.querySelector('.mm-infinite-controls');
      this.button = this.querySelector('[data-mm-more]');
      this.status = this.querySelector('[data-mm-status]');
      this.nav = this.querySelector('.pagination-wrapper');
      if (!this.grid || !this.controls || !('IntersectionObserver' in window)) return;
      if (!this.dataset.next) { this.hidden = true; return; }
      this.controls.hidden = false;
      if (this.nav) this.nav.hidden = true;
      this.button.addEventListener('click', () => this.loadMore(true));
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadMore(false);
      }, { rootMargin: '0px 0px 350px 0px' });
      this.observer.observe(this.controls);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async loadMore(manual) {
      if (this.busy || !this.dataset.next || !this.isConnected) return;
      if (this.section.querySelector('.collection.loading')) return;
      this.busy = true;
      this.observer.unobserve(this.controls);
      this.button.disabled = true;
      this.status.textContent = this.status.dataset.loading;
      this.controller = new AbortController();
      const initialLocation = location.href;
      let succeeded = false;
      try {
        const url = new URL(this.dataset.next, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid pagination origin');
        url.hash = '';
        url.searchParams.set('section_id', this.section.id.replace('shopify-section-', ''));
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Pagination request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || initialLocation !== location.href || this.section.querySelector('.collection.loading')) return;
        const sourceSection = html.getElementById(this.section.id) || html;
        const sourceGrid = sourceSection.querySelector(this.selector);
        if (!sourceGrid || !sourceGrid.children.length) throw new Error('Missing pagination results');
        const sourcePager = sourceSection.querySelector('mobilmax-infinite-list');
        const items = Array.from(sourceGrid.children);
        items.forEach(item => {
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
          item.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
        });
        this.grid.append(...items);
        this.dataset.next = sourcePager?.dataset.next || '';
        const sourceNav = sourcePager?.querySelector('.pagination-wrapper');
        if (this.nav && sourceNav) this.nav.innerHTML = sourceNav.innerHTML;
        if (this.nav) this.nav.hidden = true;
        if (manual) {
          const focusTarget = items[0].querySelector('a, button');
          focusTarget?.focus({ preventScroll: true });
        }
        if (!this.dataset.next) this.hidden = true;
        succeeded = true;
      } catch (error) {
        if (error.name !== 'AbortError' && this.nav) this.nav.hidden = false;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.status.textContent = '';
        if (succeeded && this.dataset.next && this.isConnected) this.observer.observe(this.controls);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
